import React, { useEffect } from 'react';

import Card from '~/components/Card';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchBoonApi } from './boonSlice.js';
import EditDeleteBtn from '~/components/EditDeleteBtn';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // optional for styling
import Datatable from '~/components/Datatable';

function Boon() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { rows } = useSelector((state) => state.heroSaga.boon);

    const columns = React.useMemo(
        () => [
            {
                name: '#',
                selector: (row) => row.id,
                maxWidth: '3rem',
            },
            {
                name: 'Name',
                sortable: true,
                maxWidth: '10rem',
                cell: (row) => {
                    return <div>{row.name}</div>;
                },
            },
            {
                name: 'Description',
                sortable: true,
                maxWidth: '20rem',
                cell: (row) => {
                    return (
                        <Tippy content={row.description}>
                            <div className="line-clamp line-clamp--2">{row.description}</div>
                        </Tippy>
                    );
                },
            },
            {
                name: 'Adventure',
                sortable: true,
                maxWidth: '10rem',
                selector: (row) => row.adventureCategory?.name,
            },
            {
                name: 'Round list',
                sortable: true,
                maxWidth: '7rem',
                cell: (row) => {
                    const activeRounds = row.activeRounds;
                    return (
                        <>
                            <ul
                                className="py-2"
                                style={{ marginLeft: '-2rem' }}
                            >
                                {activeRounds.length > 0 &&
                                    activeRounds.map((item, i) => <li key={i}>Round {item}</li>)}
                            </ul>
                        </>
                    );
                },
            },
            {
                name: 'Turn list',
                sortable: true,
                maxWidth: '7rem',
                cell: (row) => {
                    const activeTurns = row.activeTurns;
                    return (
                        <>
                            <ul
                                className="py-2"
                                style={{ marginLeft: '-2rem' }}
                            >
                                {activeTurns.length > 0 && activeTurns.map((item, i) => <li key={i}>Turn {item}</li>)}
                            </ul>
                        </>
                    );
                },
            },
            {
                name: 'Edit',
                cell: (row) => (
                    <EditDeleteBtn
                        row={row}
                        hasDelete={false}
                    />
                ),
                maxWidth: '7rem',
            },
        ],
        [],
    );

    useEffect(() => {
        if (rows.length > 0) return;
        dispatch(fetchBoonApi(navigate));
    }, []);

    return (
        <Card>
            <div className="col-sm-10 offset-sm-1">
                <Datatable
                    columns={columns}
                    rows={rows}
                />
            </div>
        </Card>
    );
}

export default Boon;
//ref: https://codesandbox.io/s/react-bootstrap-formik-pb831?from-embed=&file=/src/form-section-1.js:436-570
/**Notes */
//(1) even though this is reset buttton, don't use type="reset" here as it will cause nested form fields (like FormikArray) unable to be reset to its inital values (I debugged and figured it out).
